<template>
  <div class="flex">
    <div class="w-[calc(100%-215px)]">
      <div class="max-w-[411px] m-auto">
        <slot name="default" />
      </div>
    </div>
    <div class="w-[190px]">
      <slot name="sidebar" />
    </div>
  </div>
</template>

<script setup>

</script>

<style>

</style>